<div class="mx-color-icon" [class]="itemClass$ | async" [style.background-color]="color$ | async">
</div>
